import { z } from 'zod';

export const StateSchema = z
  .string()
  .trim()
  .length(2, {
    message: 'Must be a valid 2-letter state code',
  })
  .regex(/^[A-Z]{2}$/, {
    message: 'State must be in uppercase letters',
  });

export const AddressSchema = z.object({
  city: z.string().trim().min(1, { message: 'Cannot be empty' }),
  state: StateSchema,
  street: z.string().trim().min(1, { message: 'Cannot be empty' }),
  zipCode: z
    .string()
    .trim()
    .length(5)
    .regex(/^\d{5}$/, {
      message: 'Must be a valid 5-digit zip code',
    }),
  complement: z.string().trim().nullish(),
});

export type Address = {
  city: string;
  state: string;
  street: string;
  zipCode: string;
  complement?: string | null;
};

export const emptyAddress: Address = {
  city: '',
  state: '',
  street: '',
  zipCode: '',
};

export type Auth0Address = Omit<Address, 'zipCode'> & {
  postalCode: string;
};
